import PropTypes from 'prop-types'

import Icon from '../Icons'
import { getAssetLink } from '../../helpers/get-asset-link'

const DropdownOption = ({ item, onSelectOption, isCollapsable, isOpen, onOpenOrClose }) => {
  return isCollapsable ? (
    <div className="dropdown-option group-dropdown" onClick={() => onOpenOrClose(item.groupName)}>
      <Icon
        icon="lock"
        viewBox={'0 0 17 17'}
        svgProps={{ fillRule: 'evenodd', clipRule: 'evenodd' }}
      />
      <div>{item.groupName}</div>
      <div className={`arrow-icon ${isOpen(item.groupName) ? 'open' : 'closed'}`}>
        <Icon icon="arrow" />
      </div>
    </div>
  ) : (
    <div
      className="dropdown-option"
      onClick={onSelectOption ? () => onSelectOption(item.value) : null}
    >
      {item.icon ? (
        <Icon
          icon={`${item.icon}`}
          viewBox={'0 0 17 17'}
          svgProps={{ fillRule: 'evenodd', clipRule: 'evenodd' }}
        />
      ) : null}
      {item.avatar ? (
        <div className="avatar-container">
          <img
            src={getAssetLink({
              path: 'chitown-avatar/avatar',
              file: item.avatar,
            })}
          />
        </div>
      ) : null}
      <div>{item.label}</div>
      {item.unit && <div className="unit-container">#{item.unit}</div>}
    </div>
  )
}

DropdownOption.propTypes = {
  item: PropTypes.object,
  onSelectOption: PropTypes.func,
  isCollapsable: PropTypes.bool,
  isOpen: PropTypes.func,
  onOpenOrClose: PropTypes.func,
}

export default DropdownOption
